import { of, concat } from 'rxjs'
import { concatMap, switchMap } from 'rxjs/operators'
import {
  createClearLoading$,
  createLoading$,
} from '@apiEnabler/api-enabler-common/lib/loading'
import {
  updatePaymentHistoryState,
  updatePaymentActivityState,
  updatePaymentsGeneratedState$,
} from '@apiEnabler/ob-common/lib/payment-consents'

import { createGetPaymentHistory$ } from './services'
import { initialData$ } from './customer'
import { displayPayments$, displayPaymentDetails$ } from './intents'
import { createStoreNavigateTo$ } from './navigation'

const createLoadPaymentHistory$ = paymentId =>
  createGetPaymentHistory$(paymentId).pipe(
    concatMap(activityAudits =>
      of(
        updatePaymentHistoryState(paymentId, activityAudits),
        updatePaymentActivityState(paymentId, activityAudits)
      )
    )
  )

export const paymentDetailsDisplay$ = displayPaymentDetails$.pipe(
  switchMap(paymentId =>
    concat(
      initialData$,
      createLoading$('Loading payment details'),
      createStoreNavigateTo$(`/payments/${paymentId}`),
      updatePaymentsGeneratedState$,
      createLoadPaymentHistory$(paymentId),
      createClearLoading$('Loading payment details')
    )
  )
)

export const paymentsDisplay$ = displayPayments$.pipe(
  switchMap(({ search }) =>
    concat(
      initialData$,
      createLoading$('Loading payments'),
      createStoreNavigateTo$('/payments', {}, search),
      updatePaymentsGeneratedState$,
      createClearLoading$('Loading payments')
    )
  )
)
